import { ssrApi } from 'api/ssr';
import {
  GuidesPage,
  Props as GuidesPageProps,
} from 'components/template/guides';
import { IBlogPost } from 'constants/types';
import { ParsedUrlQuery } from 'querystring';

const CATEGORY_PREVIEW_LIMIT = 8;

const toPostPreview = (post: IBlogPost): Partial<IBlogPost> => ({
  _id: post._id,
  slug: post.slug,
  type: post.type,
  title: post.title,
  imageUrl: post.imageUrl,
  category: post.category,
  commentsCount: post.commentsCount,
  last_modified: post.last_modified,
});

const toPostPreviews = (posts: IBlogPost[]) =>
  posts.map(toPostPreview) as IBlogPost[];

export default function Guides({
  top,
  postsCasinosCategory,
  postsSlotsCategory,
  postsRtpChecksCategory,
  postsOtherCategory,
  category,
}: GuidesPageProps) {
  return (
    <GuidesPage
      top={top}
      postsOtherCategory={postsOtherCategory}
      postsCasinosCategory={postsCasinosCategory}
      postsSlotsCategory={postsSlotsCategory}
      postsRtpChecksCategory={postsRtpChecksCategory}
      category={category}
    />
  );
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const { category } = query;
  const { results: top } = await ssrApi.guides.list({
    isTop: true,
    limit: 4,
    type: 'guide',
  });

  const { results: postsCasinosCategory } = await ssrApi.guides.list({
    category: 'casinos',
    limit: CATEGORY_PREVIEW_LIMIT,
    type: 'guide',
  });
  const { results: postsRtpChecksCategory } = await ssrApi.guides.list({
    category: 'rtpchecks',
    limit: CATEGORY_PREVIEW_LIMIT,
    type: 'guide',
  });

  const { results: postsSlotsCategory } = await ssrApi.guides.list({
    category: 'slots',
    limit: CATEGORY_PREVIEW_LIMIT,
    type: 'guide',
  });

  const { results: postsOtherCategory } = await ssrApi.guides.list({
    category: 'other',
    limit: CATEGORY_PREVIEW_LIMIT,
    type: 'guide',
  });

  return {
    props: {
      top: toPostPreviews(top),
      postsCasinosCategory: toPostPreviews(postsCasinosCategory),
      postsSlotsCategory: toPostPreviews(postsSlotsCategory),
      postsRtpChecksCategory: toPostPreviews(postsRtpChecksCategory),
      postsOtherCategory: toPostPreviews(postsOtherCategory),
      category: category ?? '',
    },
  };
}
